export default __webpack_public_path__ + "static/hire_w-91303d9973b3b17bf44a5f4e8a38495b.webp";